import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms-of-use',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss'
})
export class TermsOfUseComponent {
  tocItems = [
    { id: 'section1', title: '1. General Terms' },
    { id: 'section2', title: '2. Compliance with Facebook Policies' },
    { id: 'section3', title: '3. User Responsibilities' },
    { id: 'section4', title: '4. Restricted Activities' },
    { id: 'section5', title: '5. Data Privacy and Security' },
    { id: 'section6', title: '6. Termination of Access' },
    { id: 'section7', title: '7. Limitation of Liability' },
    { id: 'section8', title: '8. Updates to the Policy' },
  ];

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
